// src/components/RequirePermission.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useMyPermissions } from "../hooks/useMyPermissions";

/**
 * Route-level gate for pages that exist only to perform one gated action (e.g. the
 * invoice create page). Hiding the nav link isn't enough on its own: the page stays
 * reachable by URL, bookmark or an in-app redirect, and without this a sub-user could
 * fill in an entire form only to get a 403 on save.
 *
 * Owners are never gated here (they hold every permission), so they render
 * immediately with no loading state. Do NOT use this on pages that double as a
 * read-only view — e.g. /packing-list/create and /packing-list/edit/:id are also how
 * an existing packing list is opened and printed; gate their Save instead.
 */
export default function RequirePermission({ permission, children, backTo = "/dashboard", backLabel = "Back to dashboard" }) {
  const { loading, isSubUser, can } = useMyPermissions();

  if (!isSubUser || can(permission)) return children;

  if (loading) {
    return (
      <div className="container">
        <div className="card">
          <p style={{ margin: 0 }}>Checking access…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card">
        <h2 className="page-title" style={{ marginTop: 0 }}>Not available for your account</h2>
        <p>
          Your account owner hasn't given you access to this. If you need it, ask them to
          enable it for you under Profile → Sub-Users.
        </p>
        <Link to={backTo} className="btn btn--primary" style={{ textDecoration: "none" }}>
          {backLabel}
        </Link>
      </div>
    </div>
  );
}
